import React, { useEffect, useState } from "react";
import { DecompositionTreeGraph } from "@ant-design/graphs";
import PlanInfoModal from "../modal/PlanInfoModal";
import GetPlansTreeViewApi from "../../api/plans/GetPlansTreeViewApi";
import { useLocation } from "react-router-dom";
import { GetOrganizationLevelsApi } from "../../api/org-levels/GetOrganizationLevelsApi";
import PageLoader from "../sub/PageLoader";

const PlansTree = (props) => {
  const [canStart, setCanStart] = useState(false);
  const [planModal, setPlanModal] = useState(false);
  const [data, setData] = useState([]);
  const [levels, setLevels] = useState();
  const [planId, setPlanId] = useState("");
  let curLocation = useLocation();

  useEffect(() => {
    let path = curLocation.pathname;
    let id = path.split("/top-plans/");
    if (props.plan) {
      getTreeDataById();
    } else if (id[1]) {
      getTreeData();
    }
    getOrganizationLevels();
  }, [props.plan]);

  async function getTreeData() {
    let path = curLocation.pathname;
    let id = path.split("/top-plans/");
    const apiResponse = await GetPlansTreeViewApi(id[1]);
    if (apiResponse.message === "success") {
      setData(apiResponse.data);
      setCanStart(true);
    }
  }

  async function getTreeDataById() {
    const apiResponse = await GetPlansTreeViewApi(props.plan);
    if (apiResponse.message === "success") {
      setData(apiResponse.data);
      setCanStart(true);
    }
  }

  async function getOrganizationLevels() {
    const apiResponse = await GetOrganizationLevelsApi();
    if (apiResponse.message === "success") {
      setLevels(apiResponse.levels);
    }
  }

  function getNodeColor(node) {
    let nodeColor = "#91d5ff";
    levels?.forEach((level) => {
      if (level.name === node.level) {
        nodeColor = level.color;
      }
    });
    return nodeColor;
  }

  const config = {
    data,
    nodeCfg: {
      style: (node) => {
        return {
          stroke: getNodeColor(node),
          cursor: "pointer",
        };
      },
      label: {
        style: {
          cursor: "pointer",
        },
      },
      title: {
        containerStyle: (node) => {
          return {
            fill: getNodeColor(node),
            cursor: "pointer",
          };
        },
      },
      size: [180, 50],
    },
    edgeCfg: {
      type: "polyline",
    },
    behaviors: ["drag-canvas", "zoom-canvas"],
    autoFit: false,
  };

  return canStart ? (
    <>
      <div className="border">
        <DecompositionTreeGraph
          {...config}
          onReady={(graph) => {
            graph.on("node:click", (evt) => {
              setPlanId(evt.item._cfg.id);
              setPlanModal(true);
            });
          }}
        />
      </div>
      <PlanInfoModal
        visible={planModal}
        handleCancel={() => {
          setPlanModal(false);
          setPlanId("");
        }}
        planId={planId}
      />
    </>
  ) : (
    <PageLoader />
  );
};

export default PlansTree;
